import { render, staticRenderFns } from "./ShowActivityDetailsFrund.vue?vue&type=template&id=c835d7f0&"
import script from "./ShowActivityDetailsFrund.vue?vue&type=script&lang=js&"
export * from "./ShowActivityDetailsFrund.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports